import Vue from 'vue';
import users from '../../users';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'StoreRequisitions',
  components: {
    StoreRequisitionComp: require('./storeRequisition.vue').default,
  },
  mixins: [users],
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      warehousesSource: [],
      warehousesDestination: [],
      itemsInventory: [],
      requisitions: [],
      editingRequisition: {},
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      showRequisition: false,
      totalRow: 0
    }
  },
  created() {
    this.appId = this.dataObj;
    this.getInventory();
    this.getWarehouses();
    this.getRequisitions();
  },
  methods: {
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      this.getRequisitions();
    },
    getItemText(iKey) {
      return (this.itemsInventory.filter(t => t.id == iKey).length > 0) ? this.itemsInventory.filter(t => t.id == iKey)[0].name : '';
    },
    getWarehouseText(iKey) {
      return (this.warehousesSource.filter(t => t.id == iKey).length > 0) ? this.warehousesSource.filter(t => t.id == iKey)[0].name : '';
    },
    getInventory() {
      axios.post('/EmployeeApplication/GetInventoryItems', { Value: -1 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.itemsInventory = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getWarehouses() {
      axios.post('/EmployeeApplication/GetWarehouses', { Value: -1 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.warehousesSource = response.data.items;
            this.warehousesDestination = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getRequisitions() {
      var parameters = { ApplicationId: this.appId, Options: this.options };
      axios.post('/EmployeeApplication/GetStoreRequisitions', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.items.forEach(function (obj) { obj.item = { id: obj.itemId, name: '' }; });
            this.requisitions = response.data.items;
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    add() {
      this.editingRequisition = {
        applicationId: this.appId,
        id: 0,
        reqDateTime: new Date(),
        itemId: -1,
        itemName: '',
        takenQuantity: 0,
        usedQuantity: 0,
        sourceWareHouseId: 0,
        destinationWareHouseId: 0,
        ReqTimeHours: 0,
        reqTimeMin: 0,
        readonly: false,
        item: { id: -1, name: '' },
        warehousesSource: this.warehousesSource, warehousesDestination: this.warehousesDestination, itemsInventory: this.itemsInventory
      };

      var preferenceData = this.$localStorage.get('_preference');
      this.preference = JSON.parse(preferenceData);

      if (this.preference.linkToWarehouse == true) {
        this.editingRequisition.sourceWareHouseId = this.preference.warehouseId;
        this.editingRequisition.destinationWareHouseId = this.preference.warehouseId;
      }

      this.$root.$emit('store_requisition_updated');
      this.showRequisition = true;
    },
    edit(requisition) {
      this.editingRequisition = requisition;
      this.editingRequisition.warehousesSource = this.warehousesSource;
      this.editingRequisition.warehousesDestination = this.warehousesDestination;
      this.editingRequisition.itemsInventory = this.itemsInventory;
      this.editingRequisition.item = this.editingRequisition.itemsInventory.filter(inv => inv.id == this.editingRequisition.itemId)[0];
      this.editingRequisition.itemName = this.editingRequisition.itemsInventory.filter(inv => inv.id == this.editingRequisition.itemId)[0].name;

      this.editingRequisition.ReqTimeHours = moment(this.editingRequisition.reqDateTime).format('HH');
      this.editingRequisition.ReqTimeMinutes = moment(this.editingRequisition.reqDateTime).format('mm');

      this.editingRequisition.readonly = false;
      this.$root.$emit('store_requisition_updated');
      this.showRequisition = true;
    },
    saveRequisition() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/EmployeeApplication/InsertOrUpdateStoreRequisition', { Value: this.editingRequisition })
        .then(response => {
          if (response.data.data.status == 0) {
            if (this.editingRequisition.id <= 0) {
              this.editingRequisition.id = response.data.id;
              this.requisitions.push(this.editingRequisition);
              this.options.total = this.requisitions.length;
            }
            this.$alertMsg(this.$t('messages.ReqSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text);
          this.getRequisitions();
          loader.hide();
          this.showRequisition = false;
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    remove(id) {
      axios.post('/EmployeeApplication/DeleteStoreRequisition', { Value: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.ReqDeletedSuccess'), 2);
            this.getRequisitions();
          }
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    closeDialog() {
      this.editingMessage = '';
      this.getRequisitions();
      this.showRequisition = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getRequisitions();
    },
  }
}
